import { render, staticRenderFns } from "./TestDriveDetail.vue?vue&type=template&id=a0cd1488&scoped=true"
import script from "./TestDriveDetail.vue?vue&type=script&lang=js"
export * from "./TestDriveDetail.vue?vue&type=script&lang=js"
import style0 from "./TestDriveDetail.vue?vue&type=style&index=0&id=a0cd1488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cd1488",
  null
  
)

export default component.exports